export const InvoiceMenuIcon = (props) => (
  <svg
    {...props}
    width={props?.width || '20'}
    height={props?.height || '20'}
    fill={'none'}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6668 1.66406H5.00016C4.55814 1.66406 4.13421 1.83966 3.82165 2.15222C3.50909 2.46478 3.3335 2.8887 3.3335 3.33073V16.6641C3.3335 17.1061 3.50909 17.53 3.82165 17.8426C4.13421 18.1551 4.55814 18.3307 5.00016 18.3307H15.0002C15.4422 18.3307 15.8661 18.1551 16.1787 17.8426C16.4912 17.53 16.6668 17.1061 16.6668 16.6641V6.66406M11.6668 1.66406L16.6668 6.66406M11.6668 1.66406V6.66406H16.6668M13.3335 10.8307H6.66683M13.3335 14.1641H6.66683M8.3335 7.4974H6.66683"
      stroke={props?.color || '#101828'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
